<template>
    <div>
        <Banner :displayProfileButton="true" :displayHomeButton="true"></Banner>
        <v-row justify="center" v-if="eligibleScholarships">
            <v-col class="col-9">
                <v-row>
                    <div class="welcome-to-go">WELCOME TO GO!</div>
                </v-row>
                <v-row>
                    <div class="greeting-message" v-if="eligibleScholarships.length !== 0">
                        Hello {{this.profile.first_name}} <br> 
                        We are thrilled that you are interested in applying to GO.<br>
                        Based on your profile, we’ve identified that you are eligible to apply for the following GO-PEF Scholarship.
                    </div>
                     <div class="greeting-message" v-if="eligibleScholarships.length == 0" style="width: 660px">
                        Hello {{this.profile.first_name}} <br> <br>
                        We are thrilled that you are interested in applying to GO.<br> <br>
                        Unfortunately, based on your profile you are ineligible for a scholarship in the current round. Refer to the <a style="color:rgb(234, 127, 29);" href="https://gofoundation.org.au/scholarships/" target="_blank">current Scholarships & criteria on our website</a> or contact GO for more info.<br> <br> 
                        If you think you are eligible for a GO Scholarship, please click <span class="bold">My Profile</span> to review your details.
                    </div>                   
                </v-row>
                <v-row justify="center" v-if="eligibleScholarships.length !== 0">
                    <v-col md="10" sm="12">
                        <ScholarshipCard v-for="scholarship in eligibleScholarships" :key="scholarship.id" :detail="scholarship"/>
                    </v-col>
                </v-row>
                <ScholarshipCriteria v-if="eligibleScholarships.length !== 0"/>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import Client from '../client.js';
import Banner from './BannerComponent';
import ScholarshipCard from './ScholarshipComponent';
import ScholarshipCriteria from './ScholarshipCriteriaComponent';


export default {
    components:{
        Banner,
        ScholarshipCard,
        ScholarshipCriteria
    },
    data: function() {
        return {
            eligibleScholarships: undefined,
            profile: undefined,
        }
    },
    async beforeMount() {
        let client = Client();
        client.get('me/eligible_scholarships').then(res => {
            this.eligibleScholarships = res.data;
            console.log('me/eligible_scholarships'+res.data);
            console.log(res.data);
        }, () => {})
        client.get('me/profile').then(res => {
            this.profile = res.data;
            console.log('me/profile'+res.data);
            console.log(res.data);
            if(!this.profile.is_eligible) {
            //this.$router.push({name: 'eligibility.0'})
            this.$router.push({name: 'landingpage'})
        }
        }, () => {})      
    },
}
</script>
<style lang="scss" scoped>
.welcome-to-go {
  width: 265px;
  height: 38px;
  font-family: Dosis;
  font-size: 30px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 4px;
  text-align: center;
  color: black;
  margin: 30px auto 30px auto;
}

.greeting-message
{
  width: 940px;
  font-family: Hind;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  text-align: center;
  color: black;
  margin: auto;
}

.row-height-44
{
    height: 44px;
}

.row-height-51
{
    height: 51px;
}

.row-height-113
{
    height: 113px;
}

.no-row-padding
{
    padding-top: 0;
    padding-bottom: 0;
}

.bold {
    font-weight: bold;
}

</style>
